'use client';
import AppLayout from '@/components/AppLayout';
import AuditLogScreen from './components/AuditLogScreen';

export default function AuditLogPage() {
  return (
    <AppLayout>
      <AuditLogScreen />
    </AppLayout>
  );
}
